import { ProjectCardStyles } from '../../utils/cms-utils';
import ShowMore from '../../components/show-more/ShowMore';
import ProjectCardSmall from '../project-card-small/ProjectCardSmall';
import styles from './project-card-list.module.less';

const ProjectCardList = ({
    projectIds,
    actionInformation = 'General',
    className = '',
    hideProjectImages,
    projects,
    limit,
    type,
    cardTitleHeadingLevel = 2,
}) => {
    if (!projectIds && !projects) {
        return null;
    }

    const properties = typeof actionInformation === 'string' ? { info: actionInformation } : actionInformation;

    return limit ? (
        <ShowMore
            items={projectIds}
            showCount={limit}
            listCreator={(showMoreProjects) => {
                return (
                    <div
                        className={[
                            styles.projectCardContainer,
                            className,
                            type === ProjectCardStyles.STANDARD_SMALLER ? styles.projectCardContainerSmaller : '',
                            type === ProjectCardStyles.STANDARD_SMALL ? styles.projectCardContainerSmall : '',
                        ].join(' ')}
                    >
                        {showMoreProjects?.map((projectId) => (
                            <ProjectCardSmall
                                key={projectId}
                                projectId={projectId}
                                properties={properties}
                                hideProjectImage={hideProjectImages}
                                titleHeadingLevel={cardTitleHeadingLevel}
                            />
                        ))}
                    </div>
                );
            }}
        />
    ) : (
        <div
            className={[
                styles.projectCardContainer,
                className,
                type === ProjectCardStyles.STANDARD_SMALLER ? styles.projectCardContainerSmaller : '',
                type === ProjectCardStyles.STANDARD_SMALL ? styles.projectCardContainerSmall : '',
            ].join(' ')}
        >
            {projectIds?.map((projectId) => (
                <ProjectCardSmall
                    key={projectId}
                    projectId={projectId}
                    actionInformation={actionInformation}
                    hideProjectImage={hideProjectImages}
                    titleHeadingLevel={cardTitleHeadingLevel}
                />
            ))}
        </div>
    );
};

export default ProjectCardList;
